import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FiLock, FiSave } from "react-icons/fi";
import AdminLayout from "../../components/layout/AdminLayout";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function Pengaturan() {
  const { token } = useAuth(); // ← pakai session token

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword) {
      toast.error("kata sandi lama dan kata sandi baru wajib diisi");
      return;
    }

    try {
      setLoading(true);

      await axios.put(
        "https://backend.smpn1kamal.sch.id/api/change-password",
        { oldPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Password berhasil diubah");
      setOldPassword("");
      setNewPassword("");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Gagal mengubah kata sandi"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-4">
        {/* ===== HEADER ===== */}
        <div>
          <h1 className="text-2xl font-bold text-indigo-600">
            Pengaturan Akun
          </h1>
          <p className="text-gray-500">
            Ubah kata sandi akun Anda untuk menjaga keamanan sistem.
          </p>
        </div>

        {/* ===== CARD FORM ===== */}
        <div className="bg-white rounded-2xl shadow-md p-6 max-w-xl">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* PASSWORD LAMA */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Kata Sandi Lama
              </label>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  placeholder="Masukkan kata sandi lama"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  className="
                    w-full border border-gray-300 rounded-full
                    pl-10 pr-4 py-2.5 text-sm
                    focus:outline-none focus:ring-2 focus:ring-indigo-500
                    transition
                  "
                />
              </div>
            </div>

            {/* PASSWORD BARU */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Kata Sandi Baru
              </label>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  placeholder="Masukkan kata sandi baru"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="
                    w-full border border-gray-300 rounded-full
                    pl-10 pr-4 py-2.5 text-sm
                    focus:outline-none focus:ring-2 focus:ring-indigo-500
                    transition
                  "
                />
              </div>
            </div>

            {/* BUTTON */}
            <div className="pt-2">
              <button
                type="submit"
                disabled={loading}
                className="
                  flex items-center justify-center gap-2
                  bg-indigo-500 text-white
                  px-6 py-2.5 rounded-full text-sm font-semibold
                  hover:bg-indigo-600 transition
                  disabled:opacity-50 disabled:cursor-not-allowed
                "
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      />
                    </svg>
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <FiSave size={16} />
                    Simpan
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}